import locales from './langs';
import router from './router';

export default {
  router,
  locales,
};
